import { render, staticRenderFns } from "./second.vue?vue&type=template&id=10cb1a5c&scoped=true&"
import script from "./second.vue?vue&type=script&lang=ts&"
export * from "./second.vue?vue&type=script&lang=ts&"
import style0 from "./second.vue?vue&type=style&index=0&id=10cb1a5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cb1a5c",
  null
  
)

export default component.exports